var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MyCity',{model:{value:(_vm.provAndCity),callback:function ($$v) {_vm.provAndCity=$$v},expression:"provAndCity"}})
}
var staticRenderFns = []

export { render, staticRenderFns }